import gql from 'graphql-tag';

/**
 * Query for getting what entities the user has access for.
 */
export const getAccess = gql`
  query getAccess {
    access: me {
      id
      dashboardAccess
      adminAccess
      assertions
      identityProvider
    }

    accounts(active: true, limit: 1) {
      id
    }

    organizations(active: true, limit: 1) {
      id
    }

    customers(active: true, limit: 1) {
      id
    }
  }
`;

export interface AccessResponse {
  access: {
    dashboardAccess: boolean;
    adminAccess: boolean;
    assertions: string;
    identityProvider: string;
  };
  accounts: { id: string }[];
  organizations: { id: string }[];
  customers: { id: string }[];
}
